import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationStart, RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { LayoutService } from 'src/app/RefModules/_metronic/core';
import { ManagementApiService } from 'src/app/services';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { RouteServiceService } from 'src/app/services/route-service.service';

@Component({
    selector: 'app-top-header',
    templateUrl: './top-header.component.html',
    styleUrls: ['./top-header.component.scss'],
})
export class TopHeaderComponent implements OnInit {
    headerContainerCSSClasses: string;
    headerMenuSelfDisplay: boolean;
    headerMenuSelfStatic: boolean;
    asideSelfDisplay: boolean;
    headerLogo: string;
    headerSelfTheme: string;
    headerMenuCSSClasses;
    headerMenuHTMLAttributes: any = {};
    routerLoaderTimout: any;

    display = 'none';
    isShown: boolean;
    isShownn: boolean;
    isNotificationDropdown: boolean;
    isUserDropdown: boolean;
    jwtToken: string;
    isNotificationShowing: any;
    imgSrc: string;
    flagLogin = true;
    @Output() isAdmin = new EventEmitter<string>();
    isSystemAdmin = '';
    decodedToken: any;
    loggedInUserEmail: string;
    ngUnsubscribe: Subject<any>;
    currentOrg: string;
    currentOrgId: string;
    currentInstance: string;
    isDropdownOpen = false;
    instanceNameSubscription: Subscription;

    @ViewChild('ktHeaderMenu', { static: true }) ktHeaderMenu: ElementRef;
    loader$: Observable<number>;

    private loaderSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
    private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
    subscriptions: Subscription[] = [];
    profile: any;
    graphMeEndpoint = 'https://graph.microsoft.com/v1.0/me';
    title = 'iDMS';
    accountName = '';
    isIframe = false;
    loggedIn = false;
    passwordResetAuthority = 'https://etgidmsdev.b2clogin.com/etgidmsdev.onmicrosoft.com/B2C_1_devidms_pwdreset';

    constructor(
        private layout: LayoutService,
        private router: Router,
        private http: HttpClient,
        private _managementApiService: ManagementApiService,
        private globalEmittersService: GlobalEmittersService,
        private routeServiceService: RouteServiceService,
        private elementRef: ElementRef
    ) {
        this.ngUnsubscribe = new Subject();
        // this.handleAllSubscriptions();
        this.loader$ = this.loaderSubject;
        // page progress bar percentage
        const routerSubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                // set page progress bar loading to start on NavigationStart event router
                this.loaderSubject.next(10);
            }
            if (event instanceof RouteConfigLoadStart) {
                this.loaderSubject.next(65);
            }
            if (event instanceof RouteConfigLoadEnd) {
                this.loaderSubject.next(90);
            }
            if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
                // set page progress bar loading to end on NavigationEnd event router
                this.loaderSubject.next(100);
                if (this.routerLoaderTimout) {
                    clearTimeout(this.routerLoaderTimout);
                }
                this.routerLoaderTimout = setTimeout(() => {
                    this.loaderSubject.next(0);
                }, 300);
            }
        });
        this.unsubscribe.push(routerSubscription);
    }

    ngOnInit(): void {
        let loginSuccessSubscription: Subscription;
        let loginFailureSubscription: Subscription;

        this.isIframe = window !== window.parent && !window.opener;

        if (localStorage.getItem('selectedOrganizationName')) {
            this.currentOrg = localStorage.getItem('selectedOrganizationName');
            this.currentOrgId = localStorage.getItem('selectedOrgId');
        }

        if (localStorage.getItem('currentInstanceName')) {
            this.currentInstance = localStorage.getItem('currentInstanceName');
        }
    }

    @HostListener('document:click', ['$event.target'])
    public onClick(target) {
        const clickInside = this.elementRef.nativeElement.contains(target);
        if (this.isUserDropdown || this.isNotificationDropdown) {
            this.isDropdownOpen = true;
        } else {
            this.isDropdownOpen = false;
        }
        if (!clickInside) {
            this.isUserDropdown = false;
            this.isNotificationDropdown = false;
            this.isDropdownOpen = false;
        }
    }

    notfication() {
        this.isShown = !this.isShown;
        if (this.isDropdownOpen) {
            this.isUserDropdown = false;
        }
        this.isNotificationDropdown = !this.isNotificationDropdown;
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        this.ngUnsubscribe.next(null);
        this.ngUnsubscribe.complete();
        // this.instanceNameSubscription.unsubscribe();
    }
}
